export const MAX_FLOATING_HEIGHT = 400;
export const MAX_FLOATING_WIDTH = 300;
export const MIN_FLOATING_WIDTH = 220;
